import axios from "axios";

// Open weather url and API key
const URL = 'https://api.openweathermap.org/data/2.5/weather';
const API_KEY = 'bc77b8b1962c784eb19bcad228738aee';

export const fetchWeather = async(query) => {
    const {data} = await axios.get(URL, {
        params: {
            q : query,
            units : 'metric',
            APPID : API_KEY,
        }
    });

    return data;
}